import events from "initializers/events";
import detectUserInput from "initializers/detectUserInput";
import globalViews from "initializers/globalViews";
import view from "initializers/view";
import toast from "initializers/toast";

export default [view, detectUserInput, globalViews, events, toast];
